/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupUserDtoPage } from '../../models/group-user-dto-page';

export interface ListGroupUsers$Params {
  groupId: string;
  query?: string;
  offset?: number;
  limit?: number;
}

export function listGroupUsers(http: HttpClient, rootUrl: string, params: ListGroupUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupUserDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listGroupUsers.PATH, 'get');
  if (params) {
    rb.query('groupId', params.groupId, {});
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupUserDtoPage>;
    })
  );
}

listGroupUsers.PATH = '/v0/groups/group-users';
